import { Box, Typography } from "@mui/material"
import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { SearchFilter } from "../../../components"
import { Cards } from "./card"

export const ChooseProperty = ({ t, propertyData = [], updateState = () => false, selectedProperty = {}, fetchMoreData = () => false, handleSearch = () => false, searchText = "" }) => {

    return (
        <Box p={"16px 22px 16px 22px"}>
            <Box mb={2}>
                <SearchFilter placeholder={t("Search property")} value={searchText} handleChange={(value) => handleSearch(value)} customfieldSx={{ height: "40px" }} />
            </Box>
            <InfiniteScroll
                dataLength={propertyData?.length ?? ""}
                next={fetchMoreData}
                hasMore={true}
                height={350}
            >
                <Box>
                    {propertyData?.length > 0 ? propertyData?.map((val) => {
                        return (
                            <Cards details={val} isSelect={val?.id === selectedProperty?.id ? true : false} onClick={() => updateState("selectedProperty", val)} />
                        )
                    })
                        :
                        <Typography textAlign={"center"}>{t("No Data Found")}</Typography>
                    }
                </Box>
            </InfiniteScroll>
        </Box>
    )
}